import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { Post, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import type { PostModel, StrapiResponseModel } from '@/interfaces/model';
import { postListMapper } from '@/mappers';

export const getPostBySlug = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiResponse<Post>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/noticias',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<PostModel>;
					const mapped = postListMapper(json);
					const first = mapped.list[0];
					return { data: first } satisfies StrapiResponse<Post>;
				},
			],
		}),
		controller,
	};
};
